<template>
  <div class="mt-2 mb-3">
    <!-- Subtotal -->
    <v-layout row wrap>
      <v-flex class="title font-weight-regular">{{ $tc('COMMON.ARTWORK', $cart.items.length) }}</v-flex>
      <v-flex class="title font-weight-regular" text-xs-right>
        {{ cartDetails.subtotal.amount || "-" }}
        <br />
        <span class="body-1">
          <span class="text-lowercase">({{ $t('CART.INCLUDE') }}</span>
          {{ $t('CART.VAT')}} {{ cartDetails.subtotal.vat_amount }})
        </span>
      </v-flex>
    </v-layout>
    <!-- Shipping cost -->
    <shipping-cost :cartDetails="cartDetails" />
  </div>
</template>

<script>
export default {
  props: ["cartDetails"],

  components: {
    ShippingCost: () => import("./ShippingCost")
  }
};
</script>